import { AxiosRequestConfig } from 'axios';
import { apiClient } from './client';
import { ApiResponse } from './types';

export interface TokenPair {
  access_token: string;
  refresh_token: string;
  expires_in: number;
}

export async function loginApi(
  email: string,
  password: string,
  apiUrl?: string
): Promise<TokenPair> {
  const response = await apiClient.post<ApiResponse<TokenPair>>(
    '/api/v1/admin/login',
    { email, password },
    { baseURL: apiUrl, headers: { Authorization: undefined }, _sessionId: null } as AxiosRequestConfig & { _sessionId: null }
  );
  return response.data.data;
}

export async function refreshApi(refreshToken: string): Promise<TokenPair> {
  const response = await apiClient.post<ApiResponse<TokenPair>>(
    '/api/v1/auth/refresh',
    { refresh_token: refreshToken }
  );
  return response.data.data;
}

export async function logoutApi(refreshToken?: string, apiUrl?: string): Promise<void> {
  await apiClient.post('/api/v1/auth/logout', {
    refresh_token: refreshToken,
  }, { baseURL: apiUrl, headers: { Authorization: undefined }, _sessionId: null } as AxiosRequestConfig & { _sessionId: null });
}
